import { KibButtonNew } from '@chewy/kib-controls-react';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFeatureValue } from '@/hooks/useFeatureValue';
import { FeatureConfigKeys } from '@/utils/athena-feature-config';

import styles from './StickyFreeTrialButton.module.scss';

interface Props {
  onClick: () => void;
}

export const StickyFreeTrialButton = ({ onClick }: Props) => {
  const { t } = useTranslation();

  const signupV2Enabled = useFeatureValue(FeatureConfigKeys.SIGN_UP_PAGE_V2, false);

  const [isPastSticky, setIsPastSticky] = useState(false);

  const bottomBoundaryRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let refCache: HTMLDivElement | null;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsPastSticky(entry.isIntersecting);
      },
      { root: null, threshold: 0 },
    );

    if (bottomBoundaryRef.current) {
      observer.observe(bottomBoundaryRef.current);
      refCache = bottomBoundaryRef.current;
    }

    return () => {
      if (refCache) {
        observer.unobserve(refCache);
      }
    };
  }, []);

  return (
    <>
      <div
        className={clsx([styles.stickyButtonContainer, signupV2Enabled && styles.v2Hidden])}
        data-testid="sticky-button:contianer"
      >
        <KibButtonNew
          className={clsx([styles.trialButton, isPastSticky && styles.stickyActive])}
          data-testid="sign-up:hero:open-confirmation-sheet-sticky-btn"
          onClick={onClick}
        >
          {t('loyalty.sign-up.try-for-free')}
        </KibButtonNew>
      </div>
      <div className={styles.bottomBoundary} ref={bottomBoundaryRef} />
    </>
  );
};
